import { api } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

export const examinerHistoryReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    generateExaminerHistoryPdfReport: builder.mutation<File, number>({
      query: (examinerId) =>
        api.examinerHistoryReport.getExaminerHistoryPdfReport(
          { examinerId },
          { format: 'arraybuffer' }
        ),
    }),
  }),
});

export const { useGenerateExaminerHistoryPdfReportMutation } = examinerHistoryReportApi;
